import isHexColor from './is-hex-color';
import isShadesEqual from './is-shades-equal';

export default {
  isHexColor,
  isShadesEqual,
};
